import { ToolTip } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import useEditor from "shared/hooks/useEditor"

import { ReloadIcon } from "./Styles"

const Reload = (): JSX.Element => {
  const { t } = useTranslation()
  const { refetchCatalog, isFetching } = useEditor()

  // Spin for at least 1000ms to avoid flickering
  const [isSpinning, setIsSpinning] = React.useState(false)
  React.useEffect(() => {
    if (isFetching) {
      setIsSpinning(true)
      setTimeout(() => setIsSpinning(false), 1000)
    }
  }, [isFetching])

  return (
    <ToolTip label={t("catalog_info.reload_tooltip")} toolTipPlacement="south_west">
      <ReloadIcon onClick={() => void refetchCatalog()} isSpinning={isSpinning} />
    </ToolTip>
  )
}

export default Reload
